import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EstadosLaboratorio } from './estados-laboratorio.model';

@Injectable({
  providedIn: 'root'
})
export class EntityEstadoLaboratorioService {
  url: string;
  token: string;

  constructor(private http: HttpClient) {}

  getEstadosLaboratorio(): Observable<EstadosLaboratorio[]> {
    return this.http.get<EstadosLaboratorio[]>(
      `${this.url}/estadosLaboratorio/`
    );
  }
}
